
export interface Confirmations {
  budget?: number,
  city: string,
  comment_phm?: string,
  company_name: string,
  cond_delivery: number,
  cond_offer: number,
  cond_payment: number,
  confirmation_date?: string,
  confirmation_id: number,
  country: string,
  delivery_city?: string,
  delivery_company?: string,
  delivery_country?: string,
  delivery_department?: string,
  delivery_date: string,
  delivery_postcode?: string,
  delivery_remarks: string,
  delivery_street?: string,
  description: string,
  employee_leader: number,
  employee_phm: number,
  job_date?: string,
  job_id?: string,
  name_project: string,
  order_id: string,
  postcode: string,
  project_id: string,
  request_id: string,
  status?: string,
  side_agreements?: string
  specification?: string,
  street: string,
}

export interface ConfirmationList {
  budget?: number,
  city: string,
  comment_phm?: string,
  company_name: string,
  cond_delivery: number,
  cond_offer: number,
  cond_payment: number,
  confirmation_date?: string,
  confirmation_id: number,
  country: string,
  delivery_city?: string,
  delivery_company?: string,
  delivery_country?: string,
  delivery_department?: string,
  delivery_date: string,
  delivery_postcode?: string,
  delivery_remarks: string,
  delivery_street?: string,
  description: string,
  employee_leader: number,
  employee_phm: number,
  job_date?: string,
  job_id?: string,
  name_project: string,
  order_id: string,
  part?: number,
  position?: number,
  postcode: string,
  project_id: string,
  request_id: string,
  status?: string,
  side_agreements?: string
  specification?: string,
  street: string,
}

export class SingleConfirmation {
  project_id: string = '';
  confirmation_id: number = 0;
  company_name: string = '';
  street: string = '';
  city: string = '';
  postcode: string = '';
  country: string = '';
  request_id: string = '';
  status?: string = '';
  order_id: string = '';
  job_id?: string = '';
  confirmation_date?: string = '';
  job_date?: string = '';
  name_project: string = '';
  description: string = '';
  cond_offer: number = 0;
  cond_payment: number = 0;
  cond_delivery: number = 0;
  delivery_remarks: string = '';
  delivery_date: string = '';
  employee_phm: number = 0;
  employee_leader: number = 0;
  budget?: number = 0;
  delivery_company?: string = '';
  delivery_department?: string = '';
  delivery_street?: string = '';
  delivery_city?: string = '';
  delivery_postcode?: string = '';
  delivery_country?: string = '';
  comment_phm?: string = '';
  specification?: string = '';
  side_agreements?: string = '';
}


export interface ConfirmationSteps {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
  stepIV: StepIV;
  stepV?: StepV;
}
class StepI {
    project_id: string = '';
    confirmation_id: number = 0;
    company_name: string = '';
    street: string = '';
    postcode: string = '';
    city: string = '';
    country: string = '';
    name_project: string = '';
    description: string = '';
    job_date: string = '';
    delivery_date: string = '';
    request_id: string = '';
    order_id: string = '';
    status?: string = '';
    budget?: number = 0;
}

class StepII {
  employee_phm: number = 0;
}

class StepIII {
  employee_leader: number = 0;
}

class StepIV {
  cond_delivery: number = 0;
  cond_offer: number = 0;
  cond_payment: number = 0;
  delivery_remarks: string = '';
}

class StepV {
  delivery_company: string = '';
  delivery_department: string = '';
  delivery_street: string = '';
  delivery_city: string = '';
  delivery_postcode: string = '';
  delivery_country: string = '';
}
